import * as React from 'react';

const PauseSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg id="pause_svg__eds-icon--pause_svg" viewBox="0 0 24 24" {...props}>
        <g
            id="pause_svg__Artboard-2"
            stroke="none"
            strokeWidth={1}
            fill="#45494E"
            fillRule="evenodd"
        >
            <path
                d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm9 10c0-4.963-4.038-9-9-9-4.963 0-9 4.037-9 9 0 4.962 4.037 9 9 9 4.962 0 9-4.038 9-9z"
                id="pause_svg__Mask"
            />
            <g
                id="pause_svg__Group-20"
                transform="translate(9 8)"
                stroke="#45494E"
            >
                <path d="M5.5 7.5v-7" id="pause_svg__Path" />
                <g id="pause_svg__Group-19">
                    <path d="M.25 7.5v-7" id="pause_svg__Path" />
                </g>
            </g>
        </g>
    </svg>
);

PauseSvg.displayName = 'PauseSvg';
export default PauseSvg;
